<template>
  <div class="v3-skel" :class="'v3-skel--' + shape" aria-hidden="true">
    <!-- Bar chart: (heading) + row of vertical bars -->
    <template v-if="shape === 'bar'">
      <div v-if="heading" class="v3-skel-line w30 head"></div>
      <div class="v3-skel-bars">
        <span v-for="(h, n) in barHeights" :key="n" class="v3-skel-bar" :style="{ height: h + '%' }"></span>
      </div>
    </template>

    <!-- Donut: (heading) + ring + legend lines -->
    <template v-else-if="shape === 'donut'">
      <div v-if="heading" class="v3-skel-line w30 head"></div>
      <div class="v3-skel-donut">
        <div class="v3-skel-ring"></div>
        <div class="v3-skel-grow">
          <div v-for="n in 3" :key="n" class="v3-skel-line" :class="'w' + [80, 70, 60][n % 3]"></div>
        </div>
      </div>
    </template>

    <!-- Hero: icon + title/meta lines + CTA block -->
    <template v-else-if="shape === 'hero'">
      <div class="v3-skel-hero">
        <span class="v3-skel-chip v3-skel-hero-ic"></span>
        <div class="v3-skel-grow">
          <div class="v3-skel-line w30"></div>
          <div class="v3-skel-line w70 head"></div>
        </div>
        <span class="v3-skel-chip v3-skel-hero-btn"></span>
      </div>
    </template>

    <!-- Default / list: (heading) + rows -->
    <template v-else>
      <div v-if="heading" class="v3-skel-line w30 head"></div>
      <div v-for="n in count" :key="n" class="v3-skel-line" :class="'w' + [90, 80, 70, 85][n % 4]"></div>
    </template>
  </div>
</template>

<script>
// New-portal (v3) loading skeleton for legacy (rm-portal). Mirrors the beta
// WidgetSkeleton shapes so an async v3 widget shows a shaped placeholder while
// it fetches, instead of a blank panel. Styles live in v3Widgets.scss (scoped
// under .v3-widget / .v3-skel).
export default {
  name: "cLandingV3Skeleton",
  props: {
    shape: { type: String, default: "panel" }, // bar | donut | list | panel
    count: { type: Number, default: 4 },
    heading: { type: Boolean, default: true },
  },
  data() {
    return { barHeights: [52, 78, 46, 90, 64, 82, 58, 72] };
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
